import { useQuery } from "react-query";
import { useApiService } from "../useApiService";
import { QUERY } from "../../constants/query";
import { RoomControllerService } from "../../services";

// Hook to get all rooms
export const useGetAllRooms = () => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.GET_ALL_ROOMS];

  const query = useQuery(queryKey, () =>
    handleRequest(RoomControllerService.roomControllerGetAllRooms())
  );

  return {
    ...query,
  };
};
